import { render, staticRenderFns } from "./OptionalQuestionInput.vue?vue&type=template&id=6bbb3cbc&scoped=true"
import script from "./OptionalQuestionInput.vue?vue&type=script&lang=js"
export * from "./OptionalQuestionInput.vue?vue&type=script&lang=js"
import style0 from "./OptionalQuestionInput.vue?vue&type=style&index=0&id=6bbb3cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb3cbc",
  null
  
)

export default component.exports